/**
 * Пункт «Сравните модели» на Главной: клиент открывал каталог или сравнение моделей.
 * Флаг храним по id аккаунта — иначе в одном браузере он «переезжал» бы между аккаунтами.
 */
const key = (uid: string) => `richat.models.compared.${uid}`;

export function markModelsSeen(uid: string | undefined): void {
  if (!uid) return;
  try {
    window.localStorage.setItem(key(uid), '1');
  } catch {
    /* ignore */
  }
}

export function modelsSeen(uid: string | undefined): boolean {
  if (!uid) return false;
  try {
    return window.localStorage.getItem(key(uid)) === '1';
  } catch {
    return false;
  }
}
